import type { FaireProductEntity } from "../../entity_types/product";

export const p_43je4dq54v: FaireProductEntity = {
  token: "p_43je4dq54v",
  type: "product",
  name: 'Metallic Mushroom LED Table Light-8"H-Silver',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/7eba167c9c9bce0c41cb8e8577e36769b7eb99d91bd5a9265d34d0f3f7bc98b4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/87564ab23c96c5d736af71d4b7495976b6767cbce940cbfe1b7aa872581f343b.jpeg",
    "https://cdn.faire.com/fastly/7590fd07aeac3669322fc5df5060a4c4dccbfd2ab563724877c6304131045c9c.jpeg",
  ],
  priceDollars: 45,
  description:
    "Enhance the ambiance and decor of any space with this delightful Mushroom LED Table Light. Crafted out of metal, the distinctive shape of this mushroom lamp is accentuated by its simple design for a uniquely illuminating addition to tables, bedside tables, counters and more. Comes with a built-in USB-rechargeable battery and a run time of up to 16 hours. Dimmable with 3 light levels. Also available in 2 other metallic colours. Other LED Table Lights also available.",
  tags: [],
  msrpDollars: 90,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:12.440Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
